import React from 'react';
import { Toast } from 'primereact/toast';

export const toastRef = React.createRef();

export const showGlobalToast = (severity, summary, detail) => {
    if (toastRef.current) {
        toastRef.current.show({ severity, summary, detail, life: 5000 });
    }
};

const GlobalToast = () => {
    return <Toast ref={toastRef} />;
};

export default GlobalToast;
